export default function (callback)
{
    const self = this;

    const requestBlocks = (callback) => $.ajax({
        type: "get",
        url: `${self.options.apiUserComponents}`,
        headers: {
              Authorization: self.options.accessToken,
        },
        success: function (resp) {
            if(typeof callback === "function")
            {
                callback.call(self, true, resp);
            }
        },
        error: function (jqXHR) {
            if (typeof callback === "function")
            {
                callback.call(self, false, jqXHR);
            }
        },
    });

    let data = [];
    requestBlocks(function (success, resp)
    {
        if (success)
        {
            if (resp.data)
            {
                data = resp.data
                    .filter((block) => block.deleted_at === null || block.deleted_at === undefined)
                    .map((block) =>
                    {
                        let template = $(block.template);
                        let content = $(template.html());
                        content.attr('data-keditor-snippet-id', block.id);

                        template.html(content);

                        return {
                            id: block.id,
                            title: block.title,
                            template: template.prop('outerHTML'),
                            createdAt: block.created_at,
                            updatedAt: block.updated_at,
                        };
                    });


                if (typeof callback === "function")
                {
                    callback.call(self, true, data);
                }
            }
        }
        else
        {
            if (typeof callback === "function")
            {
                callback.call(self, false, resp);
            }
        }
    });
}